/** The last few profiles opened in an environment, per browser (section 8.9: the way in at 300 profiles is search plus recents). */
const KEY = "starsach.recent-profiles";
const LIMIT = 3;

function read(): Record<string, string[]> {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? "{}") as Record<string, string[]>;
  } catch {
    return {};
  }
}

export function recentProfiles(environmentId: string): string[] {
  return read()[environmentId] ?? [];
}

export function rememberProfile(environmentId: string, profileId: string): void {
  try {
    const all = read();
    all[environmentId] = [profileId, ...(all[environmentId] ?? []).filter((p) => p !== profileId)].slice(0, LIMIT);
    localStorage.setItem(KEY, JSON.stringify(all));
  } catch {
    // Storage may be unavailable; recents are a convenience, not state.
  }
}
